import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ConsentModal::Content @close={{@close}} />",{ moduleName: "qonto-switching-bank-js/components/consent-modal.hbs" })